import { PatientSourceVaultToken } from '../types';
import { findInsurerEnum } from '@getvim-core-apps/commons';

const getPatientSourceVaultTokensInsurer = (
  patientSourceVaultTokens?: PatientSourceVaultToken[],
) => {
  const insurerSource = patientSourceVaultTokens?.find(
    (currentSource) => currentSource.isInsurer,
  )?.source;

  return findInsurerEnum(insurerSource);
};

export const getPatientInsurance = (
  patientInsurance,
  patientSourceVaultTokens?: PatientSourceVaultToken[],
) => {
  const patientSourceVaultTokensInsurer =
    getPatientSourceVaultTokensInsurer(patientSourceVaultTokens);

  if (patientInsurance && !patientInsurance.insurer) {
    patientInsurance = { ...patientInsurance, insurer: patientSourceVaultTokensInsurer };
  }

  return patientInsurance;
};
